import { useTranslation } from 'react-i18next';
import { ListEmpty, RenderDataWithFallback } from '@anytag/shared-atoms';
import { useInfluencerAddRoute } from '@anytag/shared-hooks';
import { useThreadsInfluencersContext } from '../ThreadsInfluencersContext';
import { ProfileWidget } from './ProfileWidget';

export const ThreadsInfluencersList = () => {
  const { t } = useTranslation();
  const { allowAddInfluencer, addInfluencerRoute } = useInfluencerAddRoute();
  const { loading, listRecords, getListSelectButtonProps } = useThreadsInfluencersContext();

  return (
    <RenderDataWithFallback
      loading={loading}
      hasNoData={listRecords.length === 0}
      noDataNode={
        <ListEmpty
          linkProps={allowAddInfluencer ? { label: t('add an influencer'), href: addInfluencerRoute } : undefined}
        />
      }
    >
      {listRecords.map((profile, index) => (
        <ProfileWidget
          key={`influencer-${profile.id}-${index}`}
          profile={profile}
          selectButtonProps={getListSelectButtonProps?.(profile)}
        />
      ))}
    </RenderDataWithFallback>
  );
};
